import { render } from "./EditarProveedor.vue?vue&type=template&id=1b085ff9&scoped=true"
import script from "./EditarProveedor.vue?vue&type=script&lang=js"
export * from "./EditarProveedor.vue?vue&type=script&lang=js"

import "./EditarProveedor.vue?vue&type=style&index=0&id=1b085ff9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b085ff9"]])

export default __exports__